import { PRODUCT, COMPONENT, FPTI_GROUP, SPACE_KEY } from '@common/fpti';

export const BASE_TAGS = {
  product: PRODUCT,
  component: COMPONENT,
  pgrp: FPTI_GROUP,
  space_key: SPACE_KEY
};
